export default __webpack_public_path__ + "static/media/Simple-Line-Icons4c82.1334d764.woff";